export default __webpack_public_path__ + "static/food-cutting-accomplishment-2-29f23acf70f1d836e2cfa2f8b44568a7.svg";